import React from "react";
import { ArrowForwardIos, ArrowBackIos } from "@mui/icons-material";
import { Box, Stack, useTheme } from "@mui/material";
import QueryPreservingLink from "../../components/QueryPreservingLink";
import Paginator from "paginator";
import { isEmpty } from "lodash";
import { times } from "lodash";

const Pagination = ({
  index,
  first,
  last,
  pageCount,
  category,
  author,
  pathPrefix,
  className,
}) => {
  const theme = useTheme();

  const pagination = new Paginator(10, 10);
  const paginationInfo = pagination.build(10 * pageCount, index);
  const { first_page: firstPage, last_page: lastPage } = paginationInfo;
  const items = times(lastPage - firstPage + 1, (i) => i + firstPage);

  let previousUrl = (index - 1).toString();
  const nextUrl = (index + 1).toString();

  if (previousUrl === "1") {
    previousUrl = "";
  }

  let urlPrefix = pathPrefix + "/";
  urlPrefix = !isEmpty(category)
    ? `${urlPrefix}category/${category.slug}/`
    : urlPrefix;
  urlPrefix = !isEmpty(author)
    ? `${urlPrefix}author/${author.slug}/`
    : urlPrefix;

  if (items.length === 1) return null;

  return (
    <Stack
      direction="row"
      gap={2}
      sx={{ alignItems: "center" }}
      className={className}
    >
      {!first && (
        <Stack
          component={QueryPreservingLink}
          to={urlPrefix + previousUrl}
          sx={{ alignItems: "center", color: theme.palette.primary.main }}
        >
          <ArrowBackIos />
        </Stack>
      )}

      {items.map((item) => (
        <Box
          component={QueryPreservingLink}
          to={`${urlPrefix}${item === 1 ? "" : item}`}
          sx={{
            fontSize: "20px",
            fontWeight: "bold",
            textDecoration: "none",
            color: item === index ? theme.palette.primary.main : "#A2AAB5",
          }}
          key={item}
        >
          {item}
        </Box>
      ))}

      {!last && (
        <Stack
          component={QueryPreservingLink}
          to={urlPrefix + nextUrl}
          sx={{ alignItems: "center", color: theme.palette.primary.main }}
        >
          <ArrowForwardIos />
        </Stack>
      )}
    </Stack>
  );
};

export default Pagination;
